/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const MatrixTypeDto = {
    EffectiveInRole: 'EFFECTIVE_IN_ROLE',
    SubjectMatterLeader: 'SUBJECT_MATTER_LEADER',
    EmergingLeader: 'EMERGING_LEADER',
    QuestionMark: 'QUESTION_MARK',
    Alert: 'ALERT',
    NewEmployee: 'NEW_EMPLOYEE',
    FutureLeader: 'FUTURE_LEADER'
} as const;

export type MatrixTypeDto = typeof MatrixTypeDto[keyof typeof MatrixTypeDto];



